import React from "react";
import GmailImg from "Assets/Pricing/crm/gmail.png";
import HsImg from "Assets/Pricing/crm/hs.jpg";
import PdImg from "Assets/Pricing/crm/pd.png";
import { ReactComponent as Check } from "Assets/Pricing/whiteTick.svg";

const CustomTooltip = props => {
  const {
    text = "",
    crmIcon = false,
    dialer = false,
    className = "",
    redirectText = "",
    redirectLink = "",
    hasRedirectLink = false,
    isNewTabUrl = false,
    dynamicDom = false,
    children = <></>,
    isDataOutreachData = false,
    dataOutreachCreditsContent = []
  } = props;
  const imgArr = [GmailImg, HsImg, PdImg];

  const redirectTopage = () => {
    if (isNewTabUrl) {
      window.open(redirectLink, "_blank", "noopener");
    } else {
      props && props.history && props.history.push(redirectLink);
    }
  };
  return (
    <div className="customTooltip">
      <div
        className={`sharpPointer ${className} ${dialer ? "alignRight" : ""}`}
      />
      <div
        className={`tooltipBody ${className} ${dialer ? "alignRight" : ""} ${
          crmIcon ? "crmToolTipBody" : ""
        }`}
      >
        {!crmIcon && hasRedirectLink && text ? (
          <div className="tooltipText">
            {text}
            <button className="redirectLink" onClick={redirectTopage}>
              {redirectText}
            </button>
          </div>
        ) : (
          text &&
          !dynamicDom &&
          (typeof text === "string" ? (
            <div
              className="tooltipText"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          ) : (
            <div className="tooltipText">{text}</div>
          ))
        )}
        {isDataOutreachData ? (
          <div className="dataOutreachWrapper">
            <div className="tooltipHeader">How credits are used</div>
            <hr className="tooltipDivider" />
            <div className="creditList">
              {dataOutreachCreditsContent.map((indCredit, idx) => {
                const key = Object.keys(indCredit)[0];
                const { credit, creditText } = indCredit[key] || {};
                return (
                  <div className="creditItem" key={idx}>
                    <span className="creditCheck">
                      <Check />
                    </span>
                    <span className="creditLabel">{credit}</span>
                    <span className="creditValue">{creditText}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          dynamicDom && <div className="tooltipText">{children}</div>
        )}

        {crmIcon && (
          <div className="crmIconList">
            {imgArr.map((item, index) => (
              <img src={item} alt="" key={`crmInt${index + 1}`} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomTooltip;
export { CustomTooltip };
